<div class="stock-detail">
  <div class="stock-detail__header">
    <div class="stock-detail__heading">
      <h1 class="page-title">{{ stockDetailState.stock()?.material?.name || "Stock Detail" }}</h1>
      <p class="page-subtitle">
        {{ stockDetailState.stock()?.material?.sku || "-" }} · {{ stockDetailState.stock()?.warehouse?.name || "Warehouse" }}
      </p>
    </div>

    <div class="stock-detail__actions">
      <app-button type="button" variant="secondary" (click)="goBack()">Back to Stock</app-button>
    </div>
  </div>

  @if (stockDetailState.stockError()) {
  <app-card>
    <div class="stock-detail__state stock-detail__state--error">
      <ng-glyph name="error" size="22"></ng-glyph>
      <span>{{ stockDetailState.stockError() }}</span>
    </div>
  </app-card>
  } @else {
  <app-card>
    <app-summary-panel
      title="Stock Summary"
      subtitle="Keep the current stock position visible while reviewing movement history for this warehouse record."
      [rows]="summaryRows"></app-summary-panel>
  </app-card>

  <app-card>
    <div class="stock-detail__panel-header">
      <div>
        <h2 class="stock-detail__section-title">Movement History</h2>
        <p class="stock-detail__section-subtitle">Each entry reflects a stock mutation recorded for this warehouse stock record.</p>
      </div>
    </div>

    <app-table
      [columns]="movementColumns"
      [data]="stockDetailState.movements()"
      [config]="movementConfig"
      [pagination]="movementPagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (searchChange)="onSearchChange($event)"></app-table>
  </app-card>
  }
</div>
